import SideModal from "components/SideModal";
import { useToast } from "contexts/ToastContext";
import { ChangeEvent, useRef, useState } from "react";
import { editInvestigation } from "services/advocateComplaintService";
import { AdvocateComplaints, Investigation } from "types";
import { LoadingIcon } from "utils/constant";
import { ADVOCATE_INVESTIGATION_STATUS } from "utils/constantValues";
import { useTranslation } from "contexts/i18nContext";
import "../../complaintRequest/styles/AddEvidenceModal.css";

interface ModalProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  complaintData: AdvocateComplaints;
  investigationData: Investigation;
  onRefresh: any;
}

export default function UpdateChargeDocModal({
  isOpen,
  setIsOpen,
  complaintData,
  investigationData,
  onRefresh,
}: ModalProps) {
  const { t } = useTranslation();
  const { showToast } = useToast();
  const [loading, setLoading] = useState(false);
  // const [error, setError] = useState<string | null>(null);
  // const [success, setSuccess] = useState(false);

  const [formState, setFormState] = useState({
    files: [] as File[],
    status: ADVOCATE_INVESTIGATION_STATUS.FORWARDED_TO_REGISTRAR,
    complaint: null,
  });
  const fileInputRef = useRef<HTMLInputElement>(null);

  // const handleChange = (
  //   e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  // ) => {
  //   const { name, value } = e.target;
  //   setFormState((prev) => ({ ...prev, [name]: value }));
  // };

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      setFormState((prev) => ({
        ...prev,
        files: [...Array.from(e.target.files as FileList)],
      }));
    }
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    // setError(null);
    // setSuccess(false);

    if (!investigationData) return;

    const data = new FormData();
    data.append("charge_documents", formState?.files[0] || "");
    data.append("admin_unit_id", complaintData?.admin_unit_id || "");
    data.append("org_id", complaintData?.org_id || "");
    data.append("accused_advocate_name", complaintData?.accused_name || "");
    data.append(
      "user_id_accused_advocate",
      complaintData?.userid_accused_name || "",
    );
    data.append(
      "accused_license_number",
      complaintData?.accused_license_number || "",
    );
    data.append("complaint", String(complaintData?.uu_id));
    data.append("status", formState.status);

    const investigation_id = investigationData?.uu_id || "";
    const isFormData = true;

    try {
      await editInvestigation(data, investigation_id, isFormData);

      onRefresh();
      setIsOpen(false);
      showToast(t("successfullyCreated"), "success");
      // setSuccess(true);
      setFormState({
        files: [] as File[],
        complaint: null,
        status: ADVOCATE_INVESTIGATION_STATUS?.FORWARDED_TO_REGISTRAR,
      });
    } catch (err: any) {
      console.error("Submission error:", err);
      showToast(t("submissionError"), "error");
      // setError(
      //   err?.response?.data?.message || err.message || "Something went wrong."
      // );
    } finally {
      setLoading(false);
    }
  };

  const triggerFileInput = () => {
    fileInputRef.current?.click();
  };

  if (!isOpen) return null;

  return (
    <SideModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title={t("updateChargeDocument")}
    >
      <form onSubmit={handleSubmit} className="evidence-form">
        <section className="evidence-section">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {t("chargeFile")}
          </label>
          <div className="file-upload-area" onClick={triggerFileInput}>
            <input
              type="file"
              ref={fileInputRef}
              onChange={handleFileChange}
              // multiple
              style={{ display: "none" }}
            />
            <p className="upload-text">{t("uploadFiles")}</p>
            {formState.files.length > 0 && (
              <div className="file-list">
                {formState.files.map((file, index) => (
                  <div key={index} className="file-item">
                    {file.name}
                  </div>
                ))}
              </div>
            )}
          </div>
        </section>

        <button
          type="submit"
          className="bg-black w-full text-white px-6 py-2 rounded-md hover:bg-gray-800"
          disabled={loading}
        >
          {loading ? (
            <div className="flex items-center justify-center">
              {LoadingIcon}
              {t("submitting")}
            </div>
          ) : (
            t("update")
          )}
        </button>
      </form>
    </SideModal>
  );
}
